import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

// import p1 from 'assests/Photos/ClassAssembly/2024/12C/1.jpg';
// import p2 from 'assests/Photos/ClassAssembly/2024/12C/2.jpg';
// import p3 from 'assests/Photos/ClassAssembly/2024/12C/3.jpg';
// import p4 from 'assests/Photos/ClassAssembly/2024/12C/4.jpg';

// import p5 from 'assests/Photos/ClassAssembly/2024/12A/5.jpg';
// import p6 from 'assests/Photos/ClassAssembly/2024/12A/6.jpg';
// import p7 from 'assests/Photos/ClassAssembly/2024/12A/7.jpg';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from '../ClassAssembly2023/Archive2022';
import Box from '@mui/material/Box';
import ClassAssemblySidebar2025 from '../ClassAssemblySidebar2025';
import PreprimarySidebar2025 from '../PreprimarySidebar2025/PreprimarySidebar2025';


const DussehraPrePrimary2025 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });



  const [config, setConfig] = useState({ base_image_url_2025: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  const p1 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Dussehra/1.webp`;
  const p2 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Dussehra/2.webp`;
  const p3 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Dussehra/3.webp`;
  const p4 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Dussehra/4.webp`;
  const p5 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Dussehra/5.webp`;
  const p6 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Dussehra/6.webp`;
  const p7 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Dussehra/7.webp`;
  const p8 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Dussehra/8.webp`;
  const p9 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Dussehra/9.webp`;
  const p10 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Dussehra/10.webp`;
  const p11 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Dussehra/11.webp`;
const p12 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Dussehra/12.webp`;
const p13 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Dussehra/13.webp`;
const p14 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Dussehra/14.webp`;
const p15 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Dussehra/15.webp`;
const p16 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Dussehra/16.webp`;
const p17 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Dussehra/17.webp`;
const p18 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Dussehra/18.webp`;
const p19 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Dussehra/19.webp`;
const p20 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Dussehra/20.webp`;


 

  const photos = [
    
{
    src: p1,
    source: p1,
    rows: 1,
    cols: 1,
},
{
    src: p2,
    source: p2,
    rows: 1,
    cols: 1,
},
{
    src: p3,
    source: p3,
    rows: 1,
    cols: 1,
},
{
    src: p4,
    source: p4,
    rows: 1,
    cols: 1,
},
{
    src: p5,
    source: p5,
    rows: 1,
    cols: 1,
},
{
    src: p6,
    source: p6,
    rows: 1,
    cols: 1,
},
{
    src: p7,
    source: p7,
    rows: 1,
    cols: 1,
},
{
    src: p8,
    source: p8,
    rows: 1,
    cols: 1,
},
{
    src: p9,
    source: p9,
    rows: 1,
    cols: 1,
},
{
    src: p10,
    source: p10,
    rows: 1,
    cols: 1,
},
{
    src: p11,
    source: p11,
    rows: 1,
    cols: 1,
},
{
    src: p12,
    source: p12,
    rows: 1,
    cols: 1,
},
{
    src: p13,
    source: p13,
    rows: 1,
    cols: 1,
},
{
    src: p14,
    source: p14,
    rows: 1,
    cols: 1,
},
{
    src: p15,
    source: p15,
    rows: 1,
    cols: 1,
},
{
    src: p16,
    source: p16,
    rows: 1,
    cols: 1,
},
{
    src: p17,
    source: p17,
    rows: 1,
    cols: 1,
},
{
    src: p18,
    source: p18,
    rows: 1,
    cols: 1,
},
{
    src: p19,
    source: p19,
    rows: 2.5,
    cols: 1,
},
{
    src: p20,
    source: p20,
    rows: 2.5,
    cols: 1,
}
  ];

  return (
    <Main>
        <Container>
    <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center'>
      Dussehra Celebration at Pre-Primary
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
     Class: PRE-PRIMARY Date: 25 September 2025  

        </Typography>
        <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
   “ Dussehra Celebration at Pre-Primary ”

<br/>
        </Typography>

        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
        The Pre-Primary Department of National Public School, Yeshwanthpur, joyfully celebrated Dussehra with devotion, colour and festivity. The atmosphere was vibrant as our little ones arrived in beautiful traditional attire, radiating excitement and enthusiasm.  
        <br></br>
        The celebration began with children offering their solo and group performances—each one unique and heartfelt. The audience was spellbound as our young learners showcased their talents through shloka chanting that filled the air with divinity, graceful dances reflecting festive joy, melodious singing that brought smiles to every face, engaging story narrations of Dussehra highlighting the victory of good over evil and  lively quizzes that encouraged curiosity and learning.
        <br></br>
        To add to the festive cheer, the children also enjoyed delicious festive food, making the day even more memorable.
       <br></br>
        The celebration was not only a day of Divine blessings but also an opportunity for our students to learn, share, and shine. It truly was a fabulous experience for all—a day of culture, joy and togetherness that will remain etched in the hearts of our young ones.
        <br></br>
        </Typography>
      </Box>
      <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
   “The Glowing Colours of Vibrant Festivities!”

<br/>
        </Typography>

    <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 200 : 100}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              /> 
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>
    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <PreprimarySidebar2025 />
             </Box>
         </Grid>
    </Grid> 
    </Container>
    </Main>
   
  );
};

export default DussehraPrePrimary2025;